export const fetchLaunchContext = (
    launchCode: string,
    timeoutMs = 8000
): Promise<IUser | undefined> => {
    const url = new URL('/auth/launch-context', location.origin);
    url.searchParams.set('launchCode', launchCode);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    return fetch(url, { credentials: 'omit', signal: controller.signal })
        .then((response) => response.json())
        .then((json) => {
            if (isError(json)) {
                throw new Error(json.error);
            }
            return json;
        })
        .catch((error) => {
            console.info('Launch-context failed', error);
        })
        .finally(() => clearTimeout(timeout));
};

const isError = (arg?: any): arg is { error: string } => arg && Object.hasOwn(arg, 'error');
